<template>
  <div
    class="assign-root"
    @mouseenter="showPopup = true"
    @mouseleave="showPopup = false"
  >
    <!--    <span>{{ // setNameIfTransfer() | truncate(13) }}</span>-->
    <span>{{ getNameForLastActivity() | truncate(13) }}</span>

    <div v-if="showPopup" class="tag-table">
      <div class="table-responsive">
        <table class="table table-condensed task-process-log-table">
          <thead>
            <th>Date</th>
            <th>From</th>
            <th>To</th>
            <th>Action</th>
          </thead>
          <tbody>
            <tr
              v-if="!showHistory"
              v-for="(log, idx) in getProcessLog()"
              :key="idx"
            >
              <td>{{ formatDate(log.updated_at) }}</td>
              <td>{{ log.from_user.full_name }}</td>
              <td>{{ log.client_contact_value ? log.client_contact_value : log.from_user.full_name}}</td>
              <td>{{ log.asset.toLowerCase() }}</td>
            </tr>
            <tr
              v-if="showHistory"
              v-for="(log, idx) in task.task_process_log"
              :key="idx"
            >
              <td>{{ formatDate(log.updated_at) }}</td>
              <td>{{ log.from_user.full_name }}</td>
              <td>{{ log.client_contact_value ? log.client_contact_value : log.from_user.full_name }}</td>
              <td>{{ log.asset.toLowerCase() }}</td>
            </tr>
          </tbody>
          <button
            v-if="task.task_process_log.length > 6"
            @click="showHistory = !showHistory"
            class="history-btn"
          >
            {{ showHistory ? "Close" : "Expand" }}
          </button>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import apiClientCreator from "../../../helpers/api/request";
import moment from "moment";

export default {
  name: "TaskToUser",
  props: {
    showAll: {
      type: Boolean
    },
    task: {
      type: Object,
      required: true
    },
    selectedTab: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["dictionaries", "salesPersonList"]),
    ...mapState("tasks", ["taskDictionaries"]),
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"])
  },
  mounted() {
    let arr = this.task.reply.map(t => t.reply_by);
    this.countHowManyReplied = [...new Set(arr)];
  },
  data() {
    return {
      showHistory: false,
      showPopup: false,
      searchUserNameQuery: null,
      searchUserNameQueryResult: [],
      showUsersResults: false,
      taskGroup: [],
      taskUser: this.task.task_assignment,
      taskReplies: [],
      countHowManyReplied: 0,
      name: null
    };
  },
  methods: {

    getProcessLog() {
      if (this.showAll) {
        return this.task.task_process_log.length > 0
          ? this.task.task_process_log.slice(0, 7)
          : [];
      } else {
        let newLogArray = this.task.task_process_log.filter(item => {
          return (
            item.from_user.id === this.auth.user.id ||
            item.to_user.id === this.auth.user.id
          );
        });
        return newLogArray.length > 0 ? newLogArray.slice(0, 7) : [];
      }
    },

    getNameForLastActivity() {
      if (this.task.task_type.id === 2) {
        if (this.taskUser.length > 2) {
          return `P - ${this.taskUser.length}`;
        } else {
          if (this.selectedTab === "active") {
            if (this.showAll) {
              return this.task.task_process_log[0].to_user.full_name;
            } else {
              return this.task.task_process_log[0].from_user.full_name;
            }
          } else {
            let newLogArray = this.task.task_process_log.filter(item => {
              return (
                item.from_user.id === this.auth.user.id ||
                item.to_user.id === this.auth.user.id
              );
            });
            if (this.showAll) {
              return this.task.task_process_log[0].from_user.full_name;
            } else {
              return newLogArray[0].to_user.full_name;
            }
          }
        }
      } else {
        if (this.selectedTab === "active") {
          if (this.showAll) {
            return this.task.task_process_log[0].to_user.full_name;
          } else {
            return this.task.task_process_log[0].from_user.full_name;
          }
        } else {
          let newLogArray = this.task.task_process_log.filter(item => {
            return (
              item.from_user.id === this.auth.user.id ||
              item.to_user.id === this.auth.user.id
            );
          });
          if (this.showAll) {
            return this.task.task_process_log[0] && this.task.task_process_log[0].from_user.full_name !== undefined ? this.task.task_process_log[0].from_user.full_name : "UNKNOWN"; // TODO kobi
          } else {
            return newLogArray[0].to_user.full_name;
          }
        }
      }
    },
    // getNameForLastActivity() {
    //   if (this.selectedTab === "active") {
    //     if(this.showAll){
    //       return this.task.task_process_log[0]
    //               .to_user.full_name;
    //     }else{
    //       let name = this.task.transfer.find(item=>{
    //         return item.transfer_by.id === this.auth.user.id || item.transfer_to.id === this.auth.user.id
    //       })
    //       return name ? name.transfer_to.full_name : '';
    //     }
    //   } else {
    //     if(this.showAll) {
    //       return this.task.task_process_log[0]
    //               .from_user.full_name;
    //     }else{
    //       let name = this.task.transfer.find(item=>{
    //         return item.transfer_by.id === this.auth.user.id || item.transfer_to.id === this.auth.user.id
    //       })
    //       return name ? name.transfer_to.full_name : '';
    //     }
    //
    //   }
    // },
    // getNameForLastActivity() {
    //   if (this.selectedTab === "active") {
    //     if(this.showAll){
    //       return this.task.task_process_log[0]
    //               .to_user.full_name;
    //     } else{
    //       return this.task.task_process_log[0]
    //               .from_user.full_name;
    //     }
    //
    //       // .from_user.full_name;
    //   } else {
    //     if(this.showAll) {
    //       return this.task.task_process_log[0]
    //               .to_user.full_name;
    //     }else{
    //
    //     }
    //
    //   }
    // },

    findUser(userId) {
      return this.taskReplies.find(reply => reply.reply_by === userId);
    },
    filterTaskCreator(assignments) {
      return assignments.filter(
        assigned => assigned.assigned_to.id !== assigned.assigned_by.id
      );
    },
    async getReplies() {
      this.$store.commit("clients/setLoading", true);
      const addNewClientRequest = apiClientCreator(
        `tasks/reply/${this.task.id}`
      );
      const response = await addNewClientRequest.get("");
      this.taskReplies = response.data;

      //  this.showPopup = true;
      this.$store.commit("clients/setLoading", false);
    },
    formatDate(date) {
      return moment(String(date)).format("DD/MM/YY HH:mm ");
    },

    //  setNameIfTransfer() {
    //    return this.task.transfer.length > 0
    //      ? this.task.transfer[0].transfer_to.full_name
    //      : this.task.task_assignment[0].assigned_to.full_name;
    //  },
    //  removeTaskCreator(assignArr){
    // const creator=    assignArr.find(user=>user.id===this.auth.user.id)
    //
    //    return creator.full_name
    //  }
    //

    setNameIfTransfer() {
      return this.task.task_assignment[this.task.task_assignment.length - 1]
        .assigned_to.full_name;
    },

    findTaskOwner(arr, assign) {
      if (assign) {
        const creator = arr.find(
          user => user.assigned_to.id !== user.assigned_by.id
        );
        return creator.assigned_to.full_name;
      }
      const creator = arr[0]; //.//find(user => user.transfer_to.id !== this.auth.user.id);
      return creator.transfer_to.full_name;
    }

    // findTaskCreator(arr){
    //   const creator = arr.find(user => user.assigned_by.id !== this.auth.user.id);
    //   return  creator.assigned_by.full_name;
    // }
  }
};
</script>

<style scoped>
.tag-table {
  position: absolute;
  /*top: 32px;*/
  top: 20px;
  left: 0;
  z-index: 10001;
  width: max-content;
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid #e4e8ea;
  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  text-align: center;
  font-size: 12px;
  font-family: Montserrat;
  padding: 5px;
  max-height: 400px;
  overflow-y: auto;
}

.table-responsive {
  margin-bottom: 0;
}
.table {
  margin-bottom: 0 !important;
}
.assign-root {
  position: relative;
}
.ratio-label {
  font-weight: bold;
}
.number-replied {
  color: green;
  font-weight: bold;
}
.top-creator-name {
  padding: 5px;
}
.task-process-log-table th {
  text-align: center;
}
.history-btn {
  font-family: Montserrat;
  height: 20px;
  background: #44a2d2;
  color: white;
  border: 0;
  padding: 5px;
  font-size: 10px;
  cursor: pointer;
  margin-left: 10px;
  margin-top: 2px;
  margin-bottom: 5px;
  line-height: 10px;
}
</style>
